import { Outlet } from "react-router-dom";
import classNames from "classnames";
import './main.css';

type MainProps = {
  isLeftSidebarCollapsed: boolean;
  screenWidth: number;
};

const Main = ({ isLeftSidebarCollapsed, screenWidth }: MainProps) => {
  const classes = classNames({
    body: true,
    "body-trimmed": !isLeftSidebarCollapsed && screenWidth > 768,
  });
  return (
    <div className={classes}>
      <Outlet />
    </div>
  );
};

export default Main;

